import {useDebugValue} from 'react';

import classNames from 'classnames';

const componentClassNamespace = 'search-form';
const componentClassName = `${componentClassNamespace}__day`;

const dateClassName = 'date';
const pastClassName = 'past';
const todayClassName = 'today';

function useComponent(props) {
    const {
        ariaLabelDate,
        day,
        isPast,
        isToday
    } = props;

    const className = classNames(componentClassName, {
        [dateClassName]: true,
        [pastClassName]: isPast || isToday,
        [todayClassName]: isToday
    });

    const result = {
        className,
        day,
        ariaLabelDate
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
